import AllSearchResults from "./AllSearchResults";

export default AllSearchResults;
